/** Selectable "rows per page" values for paginated lists. Every value is within the backend's 1..200 limit. */
export const PAGE_SIZE_OPTIONS = [25, 50, 100, 200];
